export default function PunchupIcon({
  color = "#FF5E2A", // primary / punchup orange
  className,
  width = "132",
  height = "120",
}: {
  color?: string;
  className?: string;
  width?: string;
  height?: string;
}) {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-auto"
      >
        <path
          d="M4.87824 119.358C5.90139 119.792 6.97022 120 8.03905 120V119.991C10.0671 119.991 12.0677 119.232 13.5933 117.785L34.8877 97.6345H110.5C122.102 97.6345 131.548 88.2869 131.548 76.8058V69.7908H64.2678C62.3267 69.7908 60.7531 68.2172 60.7531 66.2762V65.272C60.7531 63.3309 62.3267 61.7573 64.2678 61.7573H131.548V49.205H64.2678C62.3267 49.205 60.7531 47.6315 60.7531 45.6904V44.6862C60.7531 42.7451 62.3267 41.1716 64.2678 41.1716H131.548V28.6192H64.2678C62.3267 28.6192 60.7531 27.0457 60.7531 25.1046V24.1004C60.7531 22.1593 62.3267 20.5858 64.2678 20.5858H131.547C131.415 9.20723 122.02 0 110.5 0H21.0477C9.43675 0 0 9.33856 0 20.8287V112.045C0 115.236 1.90927 118.102 4.87824 119.358Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
